<template>
  <button :class="[type, size]" :disabled="disabled" @click="callback($event)" @keyup.enter="callback($event)" type="button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: String,
    size: {
      type: String,
      default: 'regular'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    callback: function (e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

button, a {
  cursor: pointer;
  text-decoration: none;
  font-family: $button-font;
  background: $primary;
  color: white;
  text-transform: uppercase;
  border: none;
  &:hover,
  &:focus,
  &:active {
    background: darken($primary, 2.5%);
    color: white;
  }

  // BUTTON TYPES
  &.cta-button {
    font-weight: 600;
    font-size: 0.75rem;
    letter-spacing: 1px;
  }

  &.edit-button {
    font-weight: 600;
    font-size: 0.65rem;
  }

  &.export-button {
    font-weight: 600;
    font-size: 0.65rem;
  }

  // BUTTON SIZES
  &.small {
    padding: 0.5rem 1rem;
  }
  &.regular {
    padding: 0.7rem 1.2rem;
    @media (max-width: 400px) {
      padding: 0.5rem 1rem;
    }
  }
  &.large {
    padding: 1rem 1.5rem;
  }

  // DISABLED BUTTON STYLES
  &:disabled {
    cursor: not-allowed;
    filter: opacity(50%);
  }
}
</style>
